export const debounce = (func, wait, scope) => {
	var timeout;
	return function() {
		var context = scope || this, args = arguments;
		var later = function() {
			timeout = null;
			func.apply(context, args);
		};
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
	};
}

export const throttle = (fn, threshold, scope) => {
	threshold || (threshold = 250);
	var last, deferTimer;

	return function() {
		var context = scope || this;
		var now = +new Date, args = arguments;

		if (last && now < last + threshold) {
			clearTimeout(deferTimer);
			deferTimer = setTimeout(function() {
				last = now;
				fn.apply(context, args);
			}, threshold);
		} else {
			last = now;
			fn.apply(context, args);
		}
	};
}

export const isInViewportTwo = (elem) => {
	var distance = elem.getBoundingClientRect();
	return ( distance.top <= (window.innerHeight || document.documentElement.clientHeight) && distance.bottom >= 0 );
}

export const forEach = (array, callback, scope) => {
	for(var i = 0; i < array.length; i++) {
		callback.call(scope, i, array[i]);
	}
}

export const setCookie = (cname, cvalue, exdays) => {
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var expires = "expires="+d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export const getCookie = (name) => {
	var pattern = RegExp(name + "=.[^;]*")
	var matched = document.cookie.match(pattern)
	return matched ? true : false;
}

export const delCookie = (cname) => {
	var d = new Date();
	d.setTime(d.getTime() - (1000*60*60*24));
	var expires = "expires=" + d.toGMTString();
	document.cookie = cname+"="+"0; "+expires + ";path=/";
}

export const isMobile = () => {
	var isMobile = false;
	if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
		isMobile = true;
	}
	return isMobile;
}

export const getRandomArbitrary = (min, max) => {
	return Math.random() * (max - min) + min;
}

export const getTranslate = (item) => {
	var transArr = [];

	if (!window.getComputedStyle) return;
	var style     = getComputedStyle(item),
	transform = style.transform || style.webkitTransform || style.mozTransform || style.msTransform;
	var mat       = transform.match(/^matrix3d\((.+)\)$/);
	if (mat) return parseFloat(mat[1].split(', ')[13]);

	mat = transform.match(/^matrix\((.+)\)$/);
	mat ? transArr.push(parseFloat(mat[1].split(', ')[4])) : transArr.push(0);
	mat ? transArr.push(parseFloat(mat[1].split(', ')[5])) : transArr.push(0);

	return transArr;
}

export const speedRamp = (nodelist, duration, callback, exponent) => {
	const steps = duration / (nodelist.length - 1);
	nodelist.forEach((t,i) => {
		setTimeout(() => {
				// console.log((1 - Math.pow(((i * steps) / duration) - 1, exponent)) * duration);
				callback(t,i);
			}, (1-Math.pow(((i * steps) / duration) - 1, exponent)) * duration);
	});
}

export const getWindowViewport = () => {
	const viewport = {};
	const vw = Math.max(window.innerWidth || 0);
	const vh = Math.max(window.innerHeight || 0);
	viewport.width = vw;
	viewport.height = vh;
	return viewport;
}

export const getSearchParameters = () => {
	var prmstr = window.location.search.substr(1);
	return prmstr != null && prmstr != "" ? this.transformToAssocArray(prmstr) : {};
}

export const transformToAssocArray = ( prmstr ) => {
	var params = {};
	var prmarr = prmstr.split("&");
	for ( var i = 0; i < prmarr.length; i++) {
		var tmparr = prmarr[i].split("=");
		params[tmparr[0]] = tmparr[1];
	}
	return params;
}

export const detectScrollDirection = (cur,lst) => {
	var st = cur || window.pageYOffset || document.documentElement.scrollTop;
	return st > lst ? 'down' : 'up';
}

export const disableScroll = (current) => {
	const scrollY = current;
	const body = document.body;
	body.style.position = 'fixed';
	body.style.top = `-${scrollY}`;
}

export const enableScroll = () => {
	const body = document.body;
	const scrollY = body.style.top;
	body.style.position = '';
	body.style.top = '';
	window.scrollTo(0, parseInt(scrollY || '0') * -1);
}

export const postAjax = (url, data, success) => {
	var params = typeof data == 'string' ? data : Object.keys(data).map(
		function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
		).join('&');

	var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
	xhr.open('POST', url);
	xhr.onreadystatechange = function() {
		if (xhr.readyState > 3 && xhr.status == 200) { success(xhr.responseText); }
	};
	xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	xhr.send(params);
	return xhr;
}

export const serialize = (form) => {
	var serialized = [];
	for (var i = 0; i < form.elements.length; i++) {
		var field = form.elements[i];
		if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;
		if (field.type === 'select-multiple') {
			for (var n = 0; n < field.options.length; n++) {
				if (!field.options[n].selected) continue;
				serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
			}
		}
		else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
			serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
		}
	}
	return serialized.join('&');
}

export const swipedetect = (el, callback) => {
	var touchsurface = el,
	swipedir,
	startX,
	startY,
	dist,
	distX,
	distY,
	threshold = 150,
	restraint = 100,
	allowedTime = 300,
	elapsedTime,
	startTime,
	handleswipe = callback || function(swipedir){};

	touchsurface.addEventListener('touchstart', function(e) {
		var touchobj = e.changedTouches[0];
		swipedir = 'none';
		dist = 0;
		startX = touchobj.pageX;
		startY = touchobj.pageY;
		startTime = new Date().getTime();
		e.preventDefault();
	},{passive: true});

	touchsurface.addEventListener('touchmove', function(e) {
		e.preventDefault();
	},{passive: true});

	touchsurface.addEventListener('touchend', function(e) {
		var touchobj = e.changedTouches[0];
		distX = touchobj.pageX - startX;
		distY = touchobj.pageY - startY;
		elapsedTime = new Date().getTime() - startTime;
		if (elapsedTime <= allowedTime) {
			if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
				swipedir = (distX < 0) ? 'left' : 'right';
			}
			else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) {
				swipedir = (distY < 0) ? 'up' : 'down';
			}
		}
		handleswipe(swipedir);
		e.preventDefault();
	},{passive: true});
}

export const isIEorEDGE = () => {
  return navigator.appName == 'Microsoft Internet Explorer' || (navigator.appName == "Netscape" && navigator.userAgent.indexOf('.NET') > -1);
}